export default __webpack_public_path__ + "static/media/sanxu-logo.7e566c0f.png";